import { setNextCardActiveAfterDeleteOrUpdate } from '@chegg-wt/core/components/ProofReader/CardsContainer/SuggestionTabs/utils'
import { onCloseQARightPanel } from '@chegg-wt/core/components/ProofReader/QuickActionRightPanel/functions/utils'
import { FeedbackTab } from '@chegg-wt/core/constants/paraphraser'
import {
  setActiveFeedbackCardId,
  setActiveFeedbackTab,
} from '@chegg-wt/core/state/paraphraser/actions'
import { rewritePanelSentencesSelector } from '@chegg-wt/core/state/paraphraser/selectors'
import { Feedback, FeedbackType } from '@chegg-wt/core/types/paraphraser'
import { AppState } from '@chegg-wt/core/state/types'
import { Dispatch } from 'redux'

export const closeQuickActionRighPanelIfOpen = (state: AppState, dispatch: Dispatch) => {
  const rewritePanelSentences = rewritePanelSentencesSelector(state)
  if (rewritePanelSentences.length > 0) {
    onCloseQARightPanel(dispatch)
  }
}

export const isSameTabOpen = (
  feedbackType: FeedbackType,
  activeFeedbackTab: FeedbackTab
): boolean => {
  return (
    (feedbackType === FeedbackType.GRAMMAR &&
      activeFeedbackTab === FeedbackTab.GRAMMAR_TAB) ||
    (feedbackType === FeedbackType.PARAPHRASE &&
      activeFeedbackTab === FeedbackTab.PARAPHRASE_TAB)
  )
}

export const openSameTab = (
  feedbackType: FeedbackType,
  activeFeedbackTab: FeedbackTab,
  dispatch: Dispatch
) => {
  if (!isSameTabOpen(feedbackType, activeFeedbackTab)) {
    dispatch(
      setActiveFeedbackTab(
        feedbackType === FeedbackType.GRAMMAR
          ? FeedbackTab.GRAMMAR_TAB
          : FeedbackTab.PARAPHRASE_TAB
      )
    )
  }
}

export const selectNextCard = (
  feedbacks: Feedback[],
  removedFeedback: Feedback,
  dispatch: Dispatch
) => {
  const filteredFeedbacks = feedbacks.filter(
    (feedback) => feedback.feedbackType === removedFeedback.feedbackType
  )
  const removedIndex = filteredFeedbacks.indexOf(removedFeedback)
  setNextCardActiveAfterDeleteOrUpdate(removedIndex, filteredFeedbacks, (id) =>
    dispatch(setActiveFeedbackCardId(id))
  )
}

export const getFeedbackKeyFromPosition = (position: Feedback['position']): string => {
  return `${position.offset}_${position.length}`
}
export const getKeyFromSentence = (id: string, sentence: string): string => {
  return `${id}_${sentence}`
}
